import styled from "styled-components";

const Link = styled.a`
  color: #fff;
  font-size: 12px;
  text-decoration: underline !important;

  &:hover {
    color: #fff;
  }
`;
export default Link;
